<template>
  <v-app id="welcome-wrap">
    <div>
      <!-- Header -->
      <header-welcome></header-welcome>

      <div class="sections">

        <div class="section-intro">
          <div class="header-title">개인정보 처리방침</div>
          <div class="header-meta">발효일 : 2020년 1월 1일</div>
        </div>

        <div class="section">
          <div class="subtitle">
            비블리오트리는 회원의 개인정보와 ‘개인콘텐츠’의 보안을 지킵니다.
          </div>
        </div>

        <div class="section">
          <div class="subtitle">
            회원이 작성한  ‘개인콘텐츠’는 회원의 소유입니다. 
          </div>
          <p>
            귀하가 비블리오트리즈 서비스에서 작성한 ‘개인콘텐츠’의 소유권은 귀하에게 있습니다. ‘개인콘텐츠’라 하더라도 이미 다른 사람의 저작권이 인정받는 콘텐츠의 경우에는 귀하가 소유권을 갖지 않습니다.
          </p>
        </div>

        <div class="section">
          <div class="subtitle">
            회원이 작성한 ‘개인콘텐츠’는 보호됩니다.
          </div>
          <p>
            저작권법 등 법적 위반이 없을 경우, 귀하가 비블리오트리즈 서비스에서 작성한 ‘개인콘텐츠’의 열람, 수정, 삭제의 권한은 귀하에게 있습니다. 당사는 귀하의 ‘개인콘텐츠’를 열람하지 않습니다. 단, 당사는 프로그램의 기술적 성능 개선을 위해 데이터베이스 수정이 필요한 경우 홈페이지 공시를 통해 데이터의 보관 형식 및 위치를 변경할 수 있습니다. 
          </p>
          <p>
            귀하의 ‘개인콘텐츠’의 보안을 위해 당사는 암호화 기능을 제공하려고 노력합니다. 당사는 ‘개인콘텐츠’의 암호화에 필요한 암호를 보관하지 않으며, 암호의 분실로 인한 ‘개인콘텐츠’의 활용 불능에 대한 책임은 귀하한테 있습니다.
          </p>
        </div>

        <div class="section">
          <div class="subtitle">
            비블리오트리즈는 귀하의 정보를 타인 혹은 다른 기관에 양도하지 않습니다.
          </div>
          <p>
            당사는 귀하의 개인정보 및 ‘개인콘텐츠’를 타인 혹은 다른 기관에 양도하지  않습니다.
          </p>
          <p>
            당사는 서비스 품질 개선을 위해 귀하가 서비스 이용시 당사에 전송되는 사용데이터, 위치정보, 장치정보를 수집할 수 있습니다.
          </p>
          <p>
            사용데이터는 쿠키 및 이와 유사한 기술을 통해 수집될 수 있습니다.
          </p>
          <p>
            서비스 이용의 위치정보는 귀하가 서비스 연결을 위해 사용하는  IP정보를 말합니다. 
          </p>
          <p>
            개인 정보를 위해 하나의 계정으로 접속되는 다수의 장치들에 대한 정보 및 사용시간을 수집하며, 비정상적인 접속이 일어날 경우 귀하에게 전자문서로 통보할 수 있습니다.
          </p>
        </div>

        <div class="section">
          <p>
            개인정보 보호와 관련해 분쟁이 발생할 경우 한국어 버전이 법적 효력을 갖습니다. 타언어 버전의 경우 귀하의 이해를 돕기 위해 제공됩니다.
          </p>
        </div>
      </div>

      <!-- Footer -->
      <footer-welcome></footer-welcome>

    </div>
  </v-app>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Privacy"
    }
  },
}
</script>

<style scoped>
  .sections {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 20px;
    max-width: 1080px;
    margin: auto;
  }

  .section {
    margin-bottom: 1.5rem;
  }

  p {
      margin-bottom: 1.2rem !important;
      line-height: 1.7 !important;
  }

  .header-title {
    padding: 40px 0;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .header-meta {
    padding: 20px 0;
    font-size: 16px;
    font-weight: 700;
  }

  .subtitle {
    padding: 20px 0;
    font-size: 20px;
    font-weight: 700;
  }
</style>


// WEBPACK FOOTER //
// src/components/spa/welcome/Privacy.vue